var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "token-list" },
    [
      _c("div", { staticClass: "token__head" }, [
        _c("div", { staticClass: "col" }, [
          _vm._v(_vm._s(_vm.$t("tokenCard.heads.name")))
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col" },
          [
            _vm._v(
              "\n            " +
                _vm._s(_vm.$t("tokenCard.heads.balance")) +
                "\n            "
            ),
            _c("tips", {
              attrs: { content: _vm.$t("tokenCard.heads.balanceTips") }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col" },
          [
            _vm._v(
              "\n            " +
                _vm._s(_vm.$t("tokenCard.heads.onroad")) +
                "\n            "
            ),
            _c("unreceive-tips", {
              attrs: { unreceivedNum: _vm.unreceivedNum }
            }),
            _vm._v(" "),
            _c("tips", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.unreceivedNum === 0,
                  expression: "unreceivedNum === 0"
                }
              ],
              attrs: { content: _vm.$t("tokenCard.heads.unreceivedTips") }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col" },
          [
            _vm._v(
              "\n            " +
                _vm._s(_vm.$t("tokenCard.heads.gate")) +
                "\n            "
            ),
            _c("tips", {
              attrs: { content: _vm.$t("tokenCard.heads.gateTips") }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "col" }, [
          _vm._v(_vm._s(_vm.$t("tokenCard.heads.totalExAmount")))
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col" },
          [
            _vm._v(
              "\n            " +
                _vm._s(_vm.$t("tokenCard.heads.availableExAmount")) +
                "\n            "
            ),
            _c("tips", {
              attrs: {
                content: _vm.$t("tokenCard.heads.availableExAmountTips")
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col" },
          [
            _c("AssetSwitch", {
              staticClass: "asset-switch",
              model: {
                value: _vm.assetType,
                callback: function($$v) {
                  _vm.assetType = $$v
                },
                expression: "assetType"
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.tokenList || !_vm.tokenList.length,
              expression: "!tokenList || !tokenList.length"
            }
          ],
          staticClass: "no-data"
        },
        [_c("div", [_vm._v(_vm._s(_vm.$t("hint.noData")))])]
      ),
      _vm._v(" "),
      _vm._l(_vm.tokenList, function(token) {
        return _c("tokenCard", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.tokenList && _vm.tokenList.length,
              expression: "tokenList && tokenList.length"
            }
          ],
          key: token.tokenId,
          attrs: { token: token, assetType: _vm.assetType }
        })
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }